import { render, staticRenderFns } from "./WorkplaceSafetyListView.vue?vue&type=template&id=3714fba4&scoped=true&"
import script from "./WorkplaceSafetyListView.vue?vue&type=script&lang=js&"
export * from "./WorkplaceSafetyListView.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceSafetyListView.vue?vue&type=style&index=0&id=3714fba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3714fba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VContainer,VPagination,VSheet})
